import { render, staticRenderFns } from "./RegisterProfile.vue?vue&type=template&id=8f7184f6&scoped=true&"
import script from "./RegisterProfile.vue?vue&type=script&lang=js&"
export * from "./RegisterProfile.vue?vue&type=script&lang=js&"
import style0 from "./RegisterProfile.vue?vue&type=style&index=0&id=8f7184f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f7184f6",
  null
  
)

export default component.exports